;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.product.show', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var showState = {
      name: 'product.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: {
        product: ['$stateParams', 'ProductManager', function ($stateParams, ProductManager) {
          return ProductManager.findById($stateParams.id, ProductManager.query({ populate: 'clientConditions.client type files image tags bpu bpu.client' }))
        }],
        vatList: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats
          })
        }],
        categories: ['CategoryService', function (CategoryService) {
          return CategoryService.getCategories().then((data) => {
            return data.map(category => category.label)
          })
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product/show/templates/product-show.template.html',
          controller: 'ProductShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/product/show/templates/product-show-toolbar.html',
          controller: 'ProductShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{::toolbar.reference}}',
        parent: 'product.list'
      }
    }

    var newState = {
      name: 'product.new',
      url: '/new',
      resolve: {
        product: ['$stateParams', 'ProductManager', function ($stateParams, ProductManager) {
          return ProductManager.create()
        }],
        vatList: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats
          })
        }],
        categories: ['CategoryService', function (CategoryService) {
          return CategoryService.getCategories().then((data) => {
            return data.map(category => category.label)
          })
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product/show/templates/product-show.template.html',
          controller: 'ProductShowController',
          controllerAs: 'show'
        }
      },
      ncyBreadcrumb: {
        label: "Création d'un produit",
        parent: 'product.list'
      }
    }

    $stateProvider
      .state(showState)
      .state(newState)
  }
})(window.angular, window._)
